/** Ora folosită în tot panoul restaurantului: Europa/București, indiferent de fusul calculatorului. */
export const ROMANIA_TZ = 'Europe/Bucharest';
export const ROMANIA_CLOCK = 'ora României (București)';

function partsInZone(date: Date, timeZone: string) {
  const formatted = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).formatToParts(date);
  const read = (type: Intl.DateTimeFormatPartTypes) => formatted.find((part) => part.type === type)?.value ?? '0';
  return {
    year: Number(read('year')),
    month: Number(read('month')),
    day: Number(read('day')),
    hour: Number(read('hour')) % 24,
    minute: Number(read('minute')),
    second: Number(read('second')),
  };
}

/** Câte milisecunde adaugă fusul față de UTC, la momentul dat. */
function zoneOffsetMs(instant: Date, timeZone: string): number {
  const wall = partsInZone(instant, timeZone);
  const asUtc = Date.UTC(wall.year, wall.month - 1, wall.day, wall.hour, wall.minute, wall.second);
  return asUtc - instant.getTime();
}

/** `2026-10-01T15:00` citit ca oră de București, întors ca instant UTC. */
export function fromRomaniaInput(value: string): string {
  const datePart = value.split('T')[0] ?? '';
  const time = value.split('T')[1] ?? '00:00';
  const [year = 1970, month = 1, day = 1] = datePart.split('-').map(Number);
  const [hour = 0, minute = 0] = time.split(':').map(Number);
  const guess = new Date(Date.UTC(year, (month ?? 1) - 1, day ?? 1, hour ?? 0, minute ?? 0));
  let offset = zoneOffsetMs(guess, ROMANIA_TZ);
  let result = new Date(guess.getTime() - offset);
  const corrected = zoneOffsetMs(result, ROMANIA_TZ);
  if (corrected !== offset) result = new Date(guess.getTime() - corrected);
  return result.toISOString();
}

/** Instant UTC afișat ca `YYYY-MM-DDTHH:mm` în ora Bucureștiului, pentru câmpurile din formular. */
export function toRomaniaInput(value: string | null): string {
  if (!value) return '';
  const wall = partsInZone(new Date(value), ROMANIA_TZ);
  const pad = (part: number) => String(part).padStart(2, '0');
  return `${wall.year}-${pad(wall.month)}-${pad(wall.day)}T${pad(wall.hour)}:${pad(wall.minute)}`;
}
